<template>
  <div id="address-data-form">
    <header class="panel__header mt-2">
      <h2 class="panel__title">TUA MORADA:</h2>
    </header>

    <div id="form-dados-endereco" class="row mt-4">
      <div class="col-12 col-sm-12">
        <div class="panel__content">
          <div class="row">
            <p class="col-12 col-sm-3">
              <select
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('pais') }"
                name="pais"
                class="form-select"
                v-model="user.pais"
                id="pais"
              >
                <option selected value="" disabled>País</option>
                <option :key="item.id" v-for="item in sortedCountries" :value="item.name"> {{ item.name }} </option>
              </select>
              <span class="invalid-feedback">
                {{ errors.first("pais") }}
              </span>
            </p>
            <p class="col-12 col-sm-3">
              <masked-input
                v-validate="'required'"
                type="text"
                name="cep"
                class="form-control"
                :class="{ 'is-invalid': errors.has('cep') }"
                v-model="user.cep"
                :mask="[/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]"
                v-on:keydown.delete="onDeleteMask"
                :guide="false"
                placeholder="Código Postal:"
                v-on:keyup="searchPostalCode"
              >
              </masked-input>

              <span class="invalid-feedback">
                {{ errors.first("cep") }}
              </span>
            </p>
            <p class="col-12 col-sm-6">
              <input
                :class="{ input: true, 'is-invalid': errors.has('cidade') }"
                name="cidade"
                v-validate="'required'"
                type="text"
                class="form-control"
                v-model="user.cidade"
                id="cidade"
                placeholder="Localidade:"
                value=""
                :disabled="addressItems.length > 0"
              />
              <span class="invalid-feedback">
                {{ errors.first("cidade") }}
              </span>
            </p>
          </div>

          <div class="row">
            <p class="col-12 col-sm-5">
              <input
                :class="{ input: true, 'is-invalid': errors.has('endereco') }"
                name="endereco"
                v-validate="'required'"
                type="text"
                class="form-control"
                v-model="user.endereco"
                id="endereco"
                placeholder="Morada:"
                value=""
                v-if="addressItems.length <= 1"
              />
              <select
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('endereco') }"
                name="endereco"
                class="form-select"
                v-model="user.endereco"
                id="endereco"
                v-else
              >
                <option selected value="" disabled>Morada...</option>
                <option :key="item.ID" v-for="item in addressItems" :value="item.Morada"> {{ item.Morada }} </option>
              </select>
              <span class="invalid-feedback">
                {{ errors.first("endereco") }}
              </span>
            </p>
            <p class="col-12 col-sm-4">
              <input
                :class="{ input: true, 'is-invalid': errors.has('bairro') }"
                name="bairro"
                type="text"
                class="form-control"
                v-model="user.bairro"
                id="bairro"
                placeholder="Bairro:"
                value=""
              />
              <span class="invalid-feedback">
                {{ errors.first("bairro") }}
              </span>
            </p>
            <p class="col-12 col-sm-3">
              <input
                :class="{ input: true, 'is-invalid': errors.has('numero') }"
                name="numero"
                v-validate="'required'"
                type="text"
                class="form-control"
                v-model="user.numero"
                id="numero"
                placeholder="Número da porta:"
                value=""
              />
              <span class="invalid-feedback">
                {{ errors.first("numero") }}
              </span>
            </p>
          </div>

          <div
            class="row"
            v-if="
              plano.apenas_carteirinha_digital != 'sim' &&
              (
                plano.entrega_clube != 'N' ||
                plano.entrega_comercial != 'N' ||
                plano.entrega_residencia != 'N'
              )
            "
          >
            <div class="col-12">
              <div class="row">
                <div class="col-12 col-sm-5">Entrega do Kit:</div>
                <div class="col-12 col-sm-7 d-flex d-md-block justify-content-center">
                  <span
                    class="ps-5 pe-4"
                    v-if="plano.id_clube == 140 && plano.entrega_clube != 'N'"
                    ><input
                      type="radio"
                      :class="{ 'is-invalid': errors.has('temkit') }"
                      v-model="user.temkit"
                      name="temkit"
                      id="temkit1"
                      class="form-check-input"
                      v-validate="'required|included:Clube,Residencia'"
                      value="Clube"
                    />
                    <label for="temkit1">No Shopping do Dragão</label></span
                  >
                  <span
                    class="ps-md-5 pe-4"
                    v-if="plano.id_clube != 140 && plano.entrega_clube != 'N'"
                    ><input
                      type="radio"
                      :class="{ 'is-invalid': errors.has('temkit') }"
                      v-model="user.temkit"
                      name="temkit"
                      id="temkit1"
                      class="form-check-input"
                      v-validate="'required|included:Clube,Residencia'"
                      value="Clube"
                    />
                    <label for="temkit1">No Clube</label></span
                  >
                  <span
                    class="ps-md-4 pe-4"
                    v-if="plano.entrega_residencia != 'N'"
                  >
                    <input
                      type="radio"
                      :class="{ 'is-invalid': errors.has('temkit') }"
                      v-model="user.temkit"
                      name="temkit"
                      id="temkit2"
                      class="form-check-input"
                      value="Residencia"
                    />
                    <label for="temkit2">No endereço cadastrado</label>
                    <span class="invalid-feedback">
                      {{ errors.first("temkit") }}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div v-show="dependentes.length > 0 && config.temDepPlus == 0" class="row p-3 my-3 border-primary" style="border-radius: 8px; margin: 0;">
            <div v-if="dependentes.length > 0 && config.temDepPlus == 0" class="col-12 col-md-6 d-flex align-items-center">
              <h3 style="margin: 0">Gostava de <b>adicionar Gamebox?</b></h3>
            </div>
            <div class="d-none d-md-block col-md-2"></div>
            <div v-if="dependentes.length > 0 && config.temDepPlus == 0" class="col-12 col-md-4 d-flex align-items-center justify-content-end">
              <span class="ps-5 pe-4 d-flex align-items-center">
                <input
                  data-vv-as="dependentes"
                  type="radio"
                  :class="{ 'is-invalid': errors.has('temDependentes') }"
                  v-model="user.temDependentes"
                  name="temDependentes"
                  id="temDependentes1"
                  class="form-check-input"
                  v-validate="'required|included:S,N'"
                  value="S"
                  style="margin: 0; margin-right: 6px;"
                />
                <label style="margin: 0;" for="temDependentes1">Sim</label>
              </span>

              <span class="ps-4 pe-4 d-flex align-items-center">
                <input
                  data-vv-as="dependentes"
                  type="radio"
                  :class="{ 'is-invalid': errors.has('temDependentes') }"
                  v-model="user.temDependentes"
                  name="temDependentes"
                  id="temDependentes2"
                  class="form-check-input"
                  value="N"
                  style="margin: 0; margin-right: 6px;"
                />
                <label style="margin: 0;" for="temDependentes2">Não</label>
                <span class="invalid-feedback">
                  {{ errors.first("temDependentes") }}
                </span>
              </span>
            </div>
            <div class="col-12" v-if="dependentes.length > 0 && config.temDepPlus != 0">
              <input
                data-vv-as="dependentes"
                type="radio"
                v-model="user.temDependentes"
                name="temDependentes"
                id="temDependentes1"
                class="form-check-input"
                value="S"
                style="display: none"
                checked="checked"
              />
            </div>
            <div class="row" v-if="dependentes.length <= 0">
              <input
                type="hidden"
                data-vv-as="dependentes"
                v-model="user.temDependentes"
                name="temDependentes"
                value="N"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <b-alert
                variant="danger"
                dismissible
                :show="error.show"
                v-model="error.show"
              >
                <div>{{ error.text }}</div>
              </b-alert>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  mounted() {
    const activeCountry = window.i18n.locale.split('_')[1]
    this.user.pais = this.countries.filter(country => country.code === activeCountry)[0].name
  },
  data() {
    return {
      fields: [
        "cep",
        "endereco",
        "bairro",
        "numero",
        "estado",
        "cidade",
        "temKit",
        "temDependentes",
      ],
      error: {
        show: false,
        text: '',
      },
      addressItems: []
    }
  },
  props: {
    user: {
      required: true,
      type: Object
    },
    config: {
      required: true,
      type: Object
    },
    plano: {
      required: true,
      type: Object
    },
    dependentes: {
      required: true,
      type: Array
    },
    countries: {
      required: true,
      type: Array
    },
  },
  computed: {
    sortedCountries() {
      const active = window.i18n.locale.split('_')[1]

      if (this.countries.filter((country) => country.code == active).length > 0) {
        return [
          ...this.countries.filter((country) => country.code == active),
          ...this.countries.filter((country) => country.code != active),
        ]
      } else {
        return this.countries
      }
    }
  },
  methods: {
    async submit() {
      try {
        if (!await this.$validator.validateAll(this.fields)) {
          throw new Error('Preencha os campos corretamente');
        }
        
        document.querySelectorAll("input").forEach(
          (input) => {
            if (input.name.match(/(dataNascimento)\_\d\_\d+/g)) {
              VMasker(input).maskPattern("99/99/9999")
            }
          }
        )

        return await this.updateUser()
      } catch (error) {
        $("html, body").animate(
          { scrollTop: $("#cadastroSocio").offset().top - 10 },
          500,
          "swing"
        )

        return false
      }
    },
    async updateUser() {
      try {
        const response = await axios.put(
          `/cadastro/dados-pessoais/${this.user.id}/end`,
          {
            userId: this.user.id,
            ...this.user,
          }
        )
  
        if (response.data.login) {
          window.location.href = "/login"
        }
        
        this.dependentes.forEach(
          (plano) => {
            if (plano.plus == "Y") {
              plano.dependentes.forEach(
                (dependente) => {
                  dependente.nomeCompleto = this.user.nome + " " + this.user.sobrenome
                }
              )
            }
          }
        )

        return true
      } catch (error) {
        this.error.show = true
        
        if (typeof error.response.data.errors.email[0] !== 'undefined') {
          this.error.message = error.response.data.errors.email[0]
        } else {
          this.error.message = "Erro interno, tente novamente mais tarde."
        }

        return false
      }
    },
    async searchPostalCode() {
      const cep = this.user.cep;
      
      if (cep.length < 8) {
        return false
      }

      try {
        const response = await axios.get(`/api/zip/PT/${cep}`)

        console.log(response.data.data)
        if (response.data.data.length == 1) {
          this.user.endereco = response.data.data.Morada
          this.user.complemento = ''
          this.user.bairro = response.data.data.bairro
          this.user.estado = response.data.data.Distrito
          this.user.cidade = response.data.data.Freguesia
        } else if (response.data.data.length > 1) {
          this.user.endereco = response.data.data[0].Morada
          this.user.complemento = ''
          this.user.bairro = response.data.data[0].bairro
          this.user.estado = response.data.data[0].Distrito
          this.user.cidade = response.data.data[0].Freguesia

          this.addressItems = response.data.data
        }
  
        // this.getMunicipalities()
      } catch (error) {
        console.log(error)        
      }
    },
    async activateAddressSelects(items) {
      
    },
    // Não faço a menor ideia do que isso faz, originalmente foi escrito pelo David Petter.
    onDeleteMask(event) {
      let value = event.target.value; 
      let char = value[value.length-1];
      if (isNaN(parseInt(char)) || char == ' ') { event.target.value = value.substring(0, value.length-1); }
    }
  },
});
</script>